export const FETCH_LEX_LICENSE_MODE_REQUEST = 'FETCH_LEX_LICENSE_MODE_REQUEST';
export const LEX_LICENSE_MODE_REQUEST_SUCCESS = 'LEX_LICENSE_MODE_REQUEST_SUCCESS';
export const LEX_LICENSE_MODE_REQUEST_ERROR = 'LEX_LICENSE_MODE_REQUEST_ERROR';
